import {Component, OnInit, ViewChild, Input, Inject} from '@angular/core';
import {CheckboxComponent} from "../checkbox/checkbox.component";
import {Patient} from "../patient/patient";
import {Caisse} from '../caisse';

@Component({
  selector: 'taxihandgo-fiche',
  templateUrl: './fiche.component.html',
  styleUrls: ['./fiche.component.scss']
})
export class FicheComponent implements OnInit {

  @ViewChild("condPecY") condPecY: CheckboxComponent;
  @ViewChild("condPecN") condPecN: CheckboxComponent;
  @Input() patient: Patient = new Patient();

  data = Caisse.caisses;

  constructor(

  ) { }

  ngOnInit() {
    this.condPecN.checkedChange.subscribe(checked => {
      if (checked){
        this.condPecY.unselect();
        this.patient.pec100 = false;
      }
    });
    this.condPecY.checkedChange.subscribe(checked => {
      if (checked){
        this.condPecN.unselect();
        this.patient.pec100 = true;
      }
    });
  }

}



// WEBPACK FOOTER //
// ./src/app/fiche/fiche.component.ts